import { Box, Progress, Text, Select } from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchComponent from "../common/SearchComponent";
import { ReactComponent as TopicsIcon } from '../../svg/tasks.svg';
import EmptyComponentTemplate from "../common/EmptyComponentTemplate";
import { searchAutocompleteList, searchReset, selectedMenu, setHeaderAdvancedSearchParams, setHeaderButtonParams, setHeaderText } from "../../redux/actions/actions";
import AllTopics from "./AllTopics";
import MobileAllTopics from "./MobileAllTopics";
import { loadCourses, loadTopics } from "../../redux/api_calls/apiCalls";


export default function Topics() {
    const dispatch = useDispatch()
    const { topicsData, isLoading /*, topicsError*/ } = useSelector(state => state.topicsState)
    const headerText = useSelector(state => state.headerState.headerText)
    const [loadMoreVisible, setLoadMoreVisible] = useState(true)
    const [visibleData, setVisibleData] = useState([])
    const [selectedCourse, setSelectedCourse] = useState('-1')
    const finalSearch = useSelector(state => state.searchState.finalSearch)
    const coursesData = useSelector(state => state.coursesState.coursesData)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const advancedSearch = useSelector(state => state.advancedSearchState)

    const loadAllTopics = () => {
        dispatch(loadTopics())
    }

    useEffect(() => {
        dispatch(setHeaderText('Topics'))
        dispatch(selectedMenu(2))
        dispatch(loadCourses())
        loadAllTopics()
        dispatch(setHeaderButtonParams({ name: 'Topic', link: '/add-topics', bgColor: '#429fff', hoverColor: '#3b8fe4' }))
        dispatch(setHeaderAdvancedSearchParams(["Keywords", "Number of Quizzes"]))
        return () => dispatch(searchReset())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (advancedSearch.length) {
            let filteredResult = []
            advancedSearch.forEach(param => {
                if (param[1].length > 0) {
                    if (param[0] === "Keywords") {
                        let searchKeywords = param[1].split(',')
                        searchKeywords = searchKeywords.map(word => word.toLowerCase())
                        topicsData.forEach(topic => {
                            let topicKeywords = topic.keywords.split(',')
                            for (let keyword of topicKeywords) {
                                if (searchKeywords.includes(keyword.toLowerCase())) {
                                    filteredResult.push(topic)
                                    break;
                                }
                            }
                        })
                    }
                    else {
                        if (filteredResult.length) {
                            filteredResult = filteredResult.filter(topic => topic.quiz_count.toString() === param[1].toString())
                        }
                        else {
                            filteredResult = topicsData.filter(topic => topic.quiz_count.toString() === param[1].toString())
                        }
                    }
                }
            })
            if (filteredResult.length) {
                setVisibleData(filteredResult)
            }
        }
        // eslint-disable-next-line
    }, [advancedSearch])

    useEffect(() => {
        dispatch(searchAutocompleteList(topicsData.map(topic => topic.title)))
        setVisibleData(topicsData.slice(0, 10))
        if (topicsData.length <= 10) {
            setLoadMoreVisible(false)
        }
        else {
            setLoadMoreVisible(true)
        }
        // eslint-disable-next-line
    }, [topicsData])

    useEffect(() => {
        if (finalSearch && finalSearch.length) {
            let newVisibleTopics = topicsData.filter(topic => finalSearch.includes(topic.title))
            if (selectedCourse !== '-1') {
                console.log(finalSearch, selectedCourse, "search with filter")
                newVisibleTopics = newVisibleTopics.filter(topic => topic.course_id.toString() === selectedCourse.toString())
            }
            setVisibleData(newVisibleTopics)
        }
        else if (selectedCourse !== '-1') {
            let newVisibleTopics = topicsData.filter(topic => topic.course_id.toString() === selectedCourse.toString())
            setVisibleData(newVisibleTopics)
        }
        else {
            setVisibleData(topicsData.slice(0, 10))
        }
        // eslint-disable-next-line
    }, [finalSearch, selectedCourse])

    const loadMoreHandler = () => {
        setVisibleData(topicsData.slice(0, visibleData.length + 10))
        if (visibleData.length + 10 >= topicsData.length) {
            setLoadMoreVisible(false)
        }
    }


    const filterHandler = (e) => {
        setSelectedCourse(e.target.value)
    }

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
                {
                    !isLoading && topicsData.length > 0 && <SearchComponent />
                }
            </Box>

            {
                isLoading ?
                    <Progress isIndeterminate size='xs' width='80%' /> :
                    !isLoading && topicsData.length === 0 ?
                        <EmptyComponentTemplate
                            name='Topic'
                            ComponentIcon={TopicsIcon}
                            bgColor='#429fff'
                            hoverColor='#3b8fe4'
                            redirectAddress='/add-topics'
                            method={loadTopics}
                        /> :
                        <>
                            <Box
                                d='flex'
                                width={['95%', '95%', '95%', '80%']}
                                justifyContent='flex-start'
                                alignItems='center'
                                mt={['2rem', '2rem', '2rem', '2']} mb='2rem'
                            >
                                <Text
                                    variant='custom'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    mr='1rem'
                                    textTransform='none'
                                >
                                    Filter by Course:
                                </Text>
                                <Select
                                    borderRadius='lg'
                                    onChange={filterHandler}
                                    width='30ch'
                                >
                                    <option value='-1'>All</option>
                                    {coursesData.map((course) => <option key={course.id} value={course.id}>{course.title}</option>)}
                                </Select>
                            </Box>
                            <AllTopics topics={visibleData} method={loadMoreHandler} loadMoreVisible={loadMoreVisible} />
                            <MobileAllTopics topics={visibleData} method={loadMoreHandler} loadMoreVisible={loadMoreVisible} />
                        </>
            }

            {/* {
                !isLoading && topicsError && <Box>{topicsError}</Box>
            } */}

        </Box>
    )
}